(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tds-collection-stack"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tds-collection-stack')) {
  customElements.define('tds-collection-stack', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.index = 0;
      this.busy = false;
      this.pointer = null;
      this.blockClickUntil = 0;
      const signal = this.controller.signal;
      const listen = (el, name, fn, options = {}) => el.addEventListener(name, fn, { ...options, signal });
      this.stage = this.querySelector('.tds-stack-stage');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.cards.length) return;
      this.classList.add('is-ready');
      this.querySelector('.tds-stack-controls').hidden = this.cards.length < 2;
      this.querySelector('.tds-stack-hint').hidden = this.cards.length < 2;
      listen(this.previous, 'click', () => this.go(-1));
      listen(this.next, 'click', () => this.go(1));
      listen(this, 'keydown', e => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key) || /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
        e.preventDefault(); this.go(e.key === 'ArrowLeft' ? -1 : 1);
      });
      listen(this.stage, 'dragstart', e => e.preventDefault());
      listen(this.stage, 'click', e => {
        if (performance.now() < this.blockClickUntil) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, { capture: true });
      const begin = (id, x, y, type) => {
        if (this.cards.length < 2 || this.busy || this.pointer) return;
        this.pointer = { id, type, x, y, dx: 0, horizontal: false, started: performance.now() };
      };
      const move = (id, x, y, event) => {
        const p = this.pointer;
        if (!p || p.id !== id) return;
        const dx = x - p.x, dy = y - p.y;
        if (!p.horizontal) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) { this.pointer = null; return; }
          p.horizontal = true;
          this.classList.add('is-dragging');
        }
        if (event.cancelable) event.preventDefault();
        p.dx = dx;
        this.cards[this.index].style.transform = `translateX(${dx}px) rotate(${Math.max(-18, Math.min(18, dx / 18))}deg)`;
      };
      const finish = (id, cancelled = false) => {
        const p = this.pointer;
        if (!p || p.id !== id) return;
        this.pointer = null;
        this.classList.remove('is-dragging');
        if (p.horizontal) this.blockClickUntil = performance.now() + 650;
        const distance = Math.abs(p.dx);
        const threshold = Math.min(64, this.cards[this.index].getBoundingClientRect().width * .18);
        const flick = distance >= 24 && distance / Math.max(1, performance.now() - p.started) >= .35;
        if (!cancelled && p.horizontal && (distance >= threshold || flick)) this.go(p.dx < 0 ? 1 : -1, p.dx);
        else this.cards[this.index].style.transform = '';
      };
      listen(this.stage, 'touchstart', e => {
        this.ignoreMouseUntil = performance.now() + 1000;
        if (e.touches.length !== 1) { if (this.pointer) finish(this.pointer.id, true); return; }
        const touch = e.touches[0];
        begin(touch.identifier, touch.clientX, touch.clientY, 'touch');
      }, { passive: true });
      listen(this.stage, 'touchmove', e => {
        if (e.touches.length !== 1) { if (this.pointer) finish(this.pointer.id, true); return; }
        const touch = Array.from(e.touches).find(t => t.identifier === this.pointer?.id);
        if (touch) move(touch.identifier, touch.clientX, touch.clientY, e);
      }, { passive: false });
      listen(this.stage, 'touchend', e => {
        const touch = Array.from(e.changedTouches).find(t => t.identifier === this.pointer?.id);
        if (touch) {
          if (this.pointer.horizontal) move(touch.identifier, touch.clientX, touch.clientY, e);
          finish(touch.identifier);
        }
      });
      listen(this.stage, 'touchcancel', () => { if (this.pointer) finish(this.pointer.id, true); });
      listen(this.stage, 'pointerdown', e => {
        if (e.pointerType === 'touch' || performance.now() < (this.ignoreMouseUntil || 0) || !e.isPrimary || e.button !== 0) return;
        begin(e.pointerId, e.clientX, e.clientY, 'pointer');
      });
      listen(document, 'pointermove', e => {
        if (this.pointer?.type === 'pointer') move(e.pointerId, e.clientX, e.clientY, e);
      }, { passive: false });
      listen(document, 'pointerup', e => {
        if (this.pointer?.type !== 'pointer') return;
        if (this.pointer.horizontal) move(e.pointerId, e.clientX, e.clientY, e);
        finish(e.pointerId);
      });
      listen(document, 'pointercancel', e => { if (this.pointer?.type === 'pointer') finish(e.pointerId, true); });
      listen(document, 'shopify:block:select', e => {
        const selected = this.cards.findIndex(c => c.dataset.blockId === e.detail.blockId);
        if (selected < 0) return;
        clearTimeout(this.timer); this.busy = false; this.pointer = null;
        this.classList.remove('is-dragging');
        this.cards.forEach(c => { c.style.transform = ''; c.style.opacity = ''; });
        this.index = selected; this.update();
      });
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      clearTimeout(this.timer); this.pointer = null;
    }
    update() {
      const n = this.cards.length;
      this.cards.forEach((card, i) => {
        const depth = (i - this.index + n) % n;
        card.dataset.depth = String(depth);
        card.inert = depth !== 0;
        card.setAttribute('aria-hidden', depth === 0 ? 'false' : 'true');
      });
      this.querySelector('[data-counter]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(n).padStart(2, '0')}`;
      this.querySelector('[data-status]').textContent = this.dataset.statusTemplate.replace('[current]', this.index + 1).replace('[total]', n);
      this.previous.disabled = this.next.disabled = n < 2;
    }
    go(direction, drag = 0) {
      if (this.busy || this.cards.length < 2) return;
      this.busy = true;
      const old = this.cards[this.index];
      const focusWasOnCard = old.contains(document.activeElement);
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const sign = drag ? Math.sign(drag) : -direction;
      old.style.transform = `translateX(${sign * Math.max(this.stage.clientWidth, 600)}px) rotate(${sign * 22}deg)`;
      old.style.opacity = '0';
      this.timer = setTimeout(() => {
        this.index = (this.index + direction + this.cards.length) % this.cards.length;
        old.style.transform = ''; old.style.opacity = '';
        this.update(); this.busy = false;
        if (focusWasOnCard) this.cards[this.index].querySelector('a')?.focus({ preventScroll: true });
      }, reduce ? 0 : 420);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
